import template from './b360ViewFilterGroup.html';
import moment from 'moment';

export function b360ViewFilterGroupDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: b360ViewFilterGroupController,
    controllerAs: 'b360ViewFilterGroup',
    bindToController: true,
    scope: {
      content: "=",
      title: "@",
      type: "@?",
      selectedItems: "=",
      onFiltersChange: '&',
      othersCount: "=?",
      hideToggle: "=?"
    }
  };
}

class b360ViewFilterGroupController {
  constructor($scope, $filter, $translate, $rootScope) {
    'ngInject';

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$filter = $filter;
    this.$translate = $translate;
    this.otherTranslated =  this.$translate.instant('VIEW360.OTHERS').toLowerCase();
    this.all = false;
    this.title = '';
    this.rowCount = 0;
    this.data = [];
    this.displayedEnabledItems = [];
    this.displayedHiddenItems = [];
    this.showEnabled = true;
    this.showHidden = true;
    this.selectedArr = [];

    this.mapWatchDereg = null;
    this.$scope.$watch(() => this.title, () => this.toggleAllLabel = `${this.$translate.instant('VIEW360.TOGGLE_ALL')} ${this.title}`);
    this.$scope.$watch(() => this.content, newValue => this.setupInitData(newValue));
  }

  changedProperties(newValue, oldValue) {
    if (!newValue) {
      return [];
    }

    const changedProps = [];
    Object.keys(newValue).forEach(prop => {
      if (newValue[prop] !== oldValue[prop]) {
        changedProps.push({property: prop, val: newValue[prop]});
      }
    });
    return changedProps;
  }

  filterData() {
    this.prepareDisplayItems();
  }

  isZero(item) {
    return item.value < 1000*61;
  }

  prepareDisplayItems() {
    const lowerSearch = this.search.trim().toLowerCase();
    if (this.hideToggle) {
      this.displayedHiddenItems = this.data.filter(item => item.name.toLowerCase().indexOf(lowerSearch) > -1);
      return;
    }

    const sortMethod = (a, b) => {
      const aa = self.selectedItems ? self.selectedItems[a.id] : 0;
      const bb = self.selectedItems ? self.selectedItems[b.id] : 0;
      return bb - aa || b.value - a.value;
    };

    const selectedFromProfitability = (key) => {
      return this.$rootScope.subTeamsScope.includes(key);
    };

    let selectedArr;
    if (this.$rootScope.subTeamsScope !== undefined) {
      selectedArr = Object.keys(this.selectedItems).filter(selectedFromProfitability);
      for (const property in this.selectedItems) {
        if (this.$rootScope.subTeamsScope.includes(property))
          this.selectedItems[property] = true;
        else
          this.selectedItems[property] = false;
      }
      const changedProps = this.changedProperties(this.selectedItems, []);
      this.onFiltersChange({changedProps});
      this.$rootScope.subTeamsScope = undefined;
    } else {
      selectedArr = Object.keys(this.selectedItems).filter(key => this.selectedItems[key]);
    }

    this.displayedEnabledItems = this.data.filter(d => selectedArr.includes(d.id))
      .filter(item => item.name.toLowerCase().indexOf(lowerSearch) > -1)
      .sort(sortMethod);
    this.displayedHiddenItems = this.data.filter(d => !selectedArr.includes(d.id))
      .filter(item => item.name.toLowerCase().indexOf(lowerSearch) > -1)
      .sort(sortMethod);
    const othersEnabledIndex = this.displayedEnabledItems.findIndex(item => item.name.toLowerCase() === this.otherTranslated);
    if (othersEnabledIndex > -1) {
      this.moveItem(this.displayedEnabledItems, othersEnabledIndex, this.displayedEnabledItems.length - 1);
    }

    const othersHiddenIndex = this.displayedHiddenItems.findIndex(item => item.name.toLowerCase() === this.otherTranslated);
    if (othersHiddenIndex > -1) {
      this.moveItem(this.displayedHiddenItems, othersHiddenIndex, this.displayedHiddenItems.length - 1);
    }

    this.showEnabled = !!this.displayedEnabledItems.length;
    this.showHidden = !!this.displayedHiddenItems.length;
    this.updateTeamsStorage();
  }

  selectionChanged(newValue, oldValue) {
    if (!this.selectedItems) {
      return;
    }

    const selectedItemsArr = Object.entries(this.selectedItems);
    const allSelected = selectedItemsArr.filter(item => item[1]).map(item => item[0]);
    const dataLength = this.data.length;
    if (this.all && !(allSelected.length === dataLength)) {
      this.all = false;
    } else if (allSelected.length === dataLength) {
      this.all = true;
    }

    if (this.onFiltersChange) {
      selectedItemsArr.forEach(item => item[item.id] = allSelected.includes(item.id));
      const changedProps = this.changedProperties(newValue, oldValue);
      this.onFiltersChange({changedProps});
      this.updateTeamsStorage();
    }
  }

  setupInitData(newValue) {
    if (!newValue) {
      return;
    }

    if (this.mapWatchDereg) {
      this.mapWatchDereg();
    }

    this.data = newValue.sort((val1, val2) => val2.value - val1.value);
    this.rowCount = this.data.length;
    this.prepareDisplayItems();
    this.mapWatchDereg = this.$scope.$watch(() => this.selectedItems, (newValue, oldValue) => this.selectionChanged(newValue, oldValue), true);
  }

  toggleAll() {
    this.all = !this.all;
    Object.keys(this.selectedItems).forEach(key => this.selectedItems[key] = this.all);
  }

  value(value) {
    if (value) {
      const duration = moment.duration(value);
      let hours = parseInt(duration.asHours());
      hours = hours < 10 ? `0${hours}` : hours;
      let minutes = +duration.minutes().toFixed(0);
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      return `${hours} h ${minutes} m`;
    } else if
      (value === 0) return '0h';

      return '';
  }

  moveItem(arr, oldIndex, newIndex) {
    while (oldIndex < 0) {
      oldIndex += arr.length;
    }
    while (newIndex < 0) {
      newIndex += arr.length;
    }
    if (newIndex >= arr.length) {
      let i = newIndex - arr.length + 1;
      while (i--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  }

  updateTeamsStorage() {
    this.$rootScope.subTeamsScope = Object.entries(this.selectedItems).map((x) => {
      if(x[1] === true)
        return x[0];
    }).filter( i => i );
  }
}
